export const ATTACHMENT_ADDED = 'ATTACHMENT_ADDED';

export const setAttachmentAddedSessionStorage = () => {
    sessionStorage.setItem(ATTACHMENT_ADDED, '1');
}
